import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./authProvider";

export default function ProtectedRoute({ children, requiredRole }) {
  const { currentUser, role, loading } = useContext(AuthContext);

  // Jeśli loading jest true, jeszcze czekamy na dane
  if (loading) return <p>Loading...</p>;
  
  // Brak zalogowania? -> do logowania
  if (!currentUser) {
    return <Navigate to="/" />;
  }

  // Jeżeli wymagana jest rola i user jej nie ma -> brak dostępu
  if (requiredRole && role !== requiredRole) {
    return <Navigate to="/brak-dostepu" />;
  }

  // Inaczej zwracamy to, co w środku (<Dashboard/> itp.)
  return children;
}